import React from 'react'
import { isMobile } from 'react-device-detect'
import { Motif } from '../../types/motifs'
import MotifSelector from './MotifSelector'

interface Props {
  motif: Motif
}

const MotifImageSection = ({ motif }: Props) => {
  return (
    <div className="relative grid w-[var(--hd-img)] grid-cols-[1fr] items-center [grid-column:1_/_1] [grid-row:1_/_1] max-sm:w-full max-sm:grid-rows-[1fr_1rem] max-sm:p-0 xxl:w-full xxl:grid-rows-[1fr_auto] xxl:gap-[var(--fk-gap)] xxl:p-0 [&_.selector-numbered-text]:font-approach-medium [&_.selector-numbered-text]:text-[length:var(--hd-selector-size)] xxl:[&_.selector-numbered-text]:text-[length:var(--fk-selector-size)] [&_.selector-text]:text-[length:var(--hd-selector-size)] xxl:[&_.selector-text]:text-[length:var(--fk-selector-size)] [&_.selectorButtonWrapper]:flex [&_.selectorButtonWrapper]:h-full [&_.selectorButtonWrapper]:flex-col [&_.selectorButtonWrapper]:items-start [&_.selectorButtonWrapper]:justify-end max-sm:[&_.selectorButtonWrapper]:text-[16px] max-sm:[&_.selectorButtonWrapper]:leading-[20px] xxl:[&_.selectorButtonWrapper]:min-h-[120px] xxl:[&_.selectorButtonWrapper]:text-[16px] xxl:[&_.selectorButtonWrapper]:leading-[40px] max-sm:[&_.selectorButtonWrapper_.selector-numbered-text]:text-[16px] max-sm:[&_.selectorButtonWrapper_.selector-numbered-text]:leading-[20px] max-sm:[&_.selectorButtonWrapper_.selector-text]:text-[16px] max-sm:[&_.selectorButtonWrapper_.selector-text]:leading-[20px]">
      {motif.vectorizedUrl && (
        <img
          className="h-[var(--hd-img)] w-auto max-w-full [align-self:start] [grid-column:1_/_1] [grid-row:1_/_1] tall-md:max-w-full max-sm:h-auto max-sm:w-full xxl:h-auto xxl:w-full"
          src={motif.vectorizedUrl}
          alt={motif.title}
        />
      )}
      {isMobile && window.innerHeight < 600 ? null : <MotifSelector motif={motif} />}
    </div>
  )
}

export default MotifImageSection
